import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React, { Component } from "react";
import DATEPICKER_OR from  "../../../../../common/custom-form/custom-date-picker.component";
import { InputFieldFloatingLabel as InputField, SelectFieldFloatingLabel as Select } from '../../../../../common/custom-form/select-filter.component';
import { MAX_LENGTH, REQUEST_TYPES, QUOTATION_CODE_DETAIL } from "../../../../../../constants/external-constants";
import Translation from "../../../../../common/translation/translation.component";
import store from "../../../../../../store";
import { actions } from 'react-redux-form';
import { orderMilestoneAction } from '../../../../../../store/external/order/milestone/order-milestone.reducer'

class ReceiptConfirmedMilestone extends Component {
    constructor(props){
        super(props)
        this.state={
            confirmationDate:null,
            commitmentDeliveryDate:null,
            carrierTrackingID: "",
            telcoRepresentativeAssigned: ""
        }
    }

    handleCarrierConfirmationDate=(date)=>{
        store.dispatch(actions.change('orderMilestoneForm.carrierConfirmationDate',date))
    }

    handleCommitmentDeliveryDate=(date)=>{
        store.dispatch(actions.change('orderMilestoneForm.vendorCommitmentDeliveryDate',date))
    }

    componentDidMount = () =>{
        const {orderMilestoneForm} = this.props;
        this.setState({
            confirmationDate: orderMilestoneForm.carrierConfirmationDate,
            commitmentDeliveryDate: orderMilestoneForm.vendorCommitmentDeliveryDate,
            carrierTrackingID: orderMilestoneForm.carrierTrackingID,
            telcoRepresentativeAssigned: orderMilestoneForm.telcoRepresentativeAssigned
        })
    }
    componentWillUnmount = () =>{
        const { orderMilestoneForm } = this.props;

        const fieldsToClear = [
            { current: this.state.confirmationDate, saved: orderMilestoneForm.carrierConfirmationDate, action: this.handleCarrierConfirmationDate },
            { current: this.state.commitmentDeliveryDate, saved: orderMilestoneForm.vendorCommitmentDeliveryDate, action: this.handleCommitmentDeliveryDate },
            { current: this.state.carrierTrackingID, saved: orderMilestoneForm.carrierTrackingID, action: (value) => store.dispatch(actions.change('orderMilestoneForm.carrierTrackingID', value)) },
            { current: this.state.telcoRepresentativeAssigned, saved: orderMilestoneForm.telcoRepresentativeAssigned, action: (value) => store.dispatch(actions.change('orderMilestoneForm.telcoRepresentativeAssigned', value)) },
        ];

        fieldsToClear.forEach(({current, saved, action}) => {
            if (current != saved && typeof action === 'function') {
                action(null);
            }
        });
    };

    render() {
        const { orderMilestoneForm, requestType,disableFields } = this.props
        const isVendComDelRequired = requestType === REQUEST_TYPES.portIn
            || requestType === REQUEST_TYPES.terminateSubscription
            || requestType === REQUEST_TYPES.portOut
            || requestType === REQUEST_TYPES.replaceOrUpgradeDevice
            || requestType === REQUEST_TYPES.changeUser
            || requestType === REQUEST_TYPES.changeVendor
            || requestType === REQUEST_TYPES.accessory
            || requestType === REQUEST_TYPES.intlRoamAccess
            || requestType === REQUEST_TYPES.other
            || requestType === REQUEST_TYPES.changeNumber
            || requestType === REQUEST_TYPES.enableHotspot
            || requestType === REQUEST_TYPES.simActivation
            || requestType === REQUEST_TYPES.suspendResumeService
            || requestType === REQUEST_TYPES.pukCode
            || requestType === REQUEST_TYPES.otherSIMReplacement
            || requestType === REQUEST_TYPES.otherChangeOfPlan
            || requestType === REQUEST_TYPES.newMobileSubscription
            || requestType === REQUEST_TYPES.simAndDevice
            || requestType === REQUEST_TYPES.newMobileDevice
            || requestType === REQUEST_TYPES.wifiDongleAndDataCard
            || requestType === REQUEST_TYPES.simAndDeviceBSA
            || requestType === REQUEST_TYPES.simOnlyBSA
            || requestType === REQUEST_TYPES.multiSIMBSA
            || requestType === REQUEST_TYPES.wifiDongleAndDataCardBIN
            || requestType === REQUEST_TYPES.voiceSIMBIN
            || requestType === REQUEST_TYPES.wifiDongleDataCardAndVoiceSIMBIN
            || requestType === REQUEST_TYPES.newCircuit
            || requestType === REQUEST_TYPES.updatePlan
            || requestType === REQUEST_TYPES.callingAccess
            || requestType === REQUEST_TYPES.roamingAccess
            || requestType === REQUEST_TYPES.terminateSubscriptionWireline ? false : true;
            return (
                <div className={`order-milestone__form message-form-body ${this.props.customClass}`}>
                    {
                        requestType !== REQUEST_TYPES.newQuotation
                            && requestType !== QUOTATION_CODE_DETAIL.newQuotation 
                            && requestType !== QUOTATION_CODE_DETAIL.upgradeQuotation ? (
                            <>
                                <DATEPICKER_OR
                                    dateOnly={true}
                                    label={<Translation translationKey={'carrier_confirmation_date'} />}
                                    startDate={orderMilestoneForm.carrierConfirmationDate}
                                    selectedDate={(date) => this.handleCarrierConfirmationDate(date)}
                                    requiredField={true}
                                    isDisable={disableFields}
                                />
                                
                                <InputField
                                    className="form-control pl-12"
                                    type="text"
                                    label={<Translation translationKey={'carrier_tracking_id'} />}
                                    value={orderMilestoneForm.carrierTrackingID}
                                    fieldProp="orderMilestoneForm.carrierTrackingID"
                                    maxLength={MAX_LENGTH.limit_100}
                                    placeholder={"Enter text here..."}
                                    requiredField={true}
                                    disabled={disableFields}
                                />
                                
                                <InputField
                                    className="form-control pl-12"
                                    type="text"
                                    label={<Translation translationKey={'telco_representative_assigned'} />}
                                    value={orderMilestoneForm.telcoRepresentativeAssigned}
                                    fieldProp="orderMilestoneForm.telcoRepresentativeAssigned"
                                    maxLength={MAX_LENGTH.limit_100}
                                    placeholder={"Enter text here..."}
                                    requiredField={true}
                                    disabled={disableFields}
                                />
                                
                                <DATEPICKER_OR
                                    dateOnly={true}
                                    label={<Translation translationKey={'vendor_committed_delivery_date'} />}
                                    startDate={orderMilestoneForm.vendorCommitmentDeliveryDate}
                                    selectedDate={(date) => this.handleCommitmentDeliveryDate(date)}   
                                    requiredField={isVendComDelRequired}
                                    isDisable={disableFields}
                                />
                            </>
                        ) :  <DATEPICKER_OR
                                dateOnly={true}
                                label={<Translation translationKey={'carrier_confirmation_date'} />}
                                startDate={orderMilestoneForm.carrierConfirmationDate}
                                selectedDate={(date) => this.handleCarrierConfirmationDate(date)} // Fixed typo here
                                requiredField={true}
                                isDisable={disableFields}
                            />
                    }
                </div>
            );
            
    }
}

export default connect(
    state => {
        const { orderMilestoneDetails,
            form: { forms: { orderMilestoneForm: { $form } } },
        } = state;
        const { orderMilestoneForm } = state.form;
        return {
            
            orderMilestoneForm,
            orderMilestoneDetails,
            $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, orderMilestoneAction),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(ReceiptConfirmedMilestone);
